import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { downloadFileFun } from '@/utils/public';
import standardTable from '@/components/standardTable/index';
import { structureList, deleteDepartment } from './../../customer/accountManage/request';
// import {deleteTable} from '@/api/userManage2';
import { mapState } from 'vuex';
import { userList, deleteTable, accountStatus, changeUploadMandatoryStatus, downloadBackNoticeTemplateInfo } from './request';
import departmentModel from './departmentModel';
import selectNoticeTemplateModel from './selectNoticeTemplateModel.vue';
export default {
  components: {
    standardTable,
    departmentModel,
    selectNoticeTemplateModel
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  data() {
    return {
      departmentDialogVisible: false,
      nodeSelect: null,
      tableHead: [
        // {title: '序号',dataIndex: 'index',scopedSlots: {customRender: 'index'},width: 80,align: 'center'},
        // {title: '账号',dataIndex: 'mobile',align: 'center'},
        // {title: '姓名',dataIndex: 'nickName',align: 'center'},
        // {title: '角色',dataIndex: 'roles',align: 'center', scopedSlots:{customRender: 'roles'}},
        // {title: '账号架构',dataIndex: 'structureLevel',align: 'center'},
        // {title: '状态', dataIndex: 'status',scopedSlots: {customRender: 'status'},align: 'center'},
        // {title: '操作',scopedSlots: {customRender: 'action'},align: 'center',width: 200}
      ],
      form: {
        customerId: '',
        structureId: '',
        name: '',
        status: undefined
      },
      tableData: [],
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      loading: false,
      selectNoticeTemplateVisible: false,
      configRow: {},
      downLoading: false
    };
  },
  watch: {
    filterText(val) {
      console.log(val);
      this.$refs.tree.filter(val);
    }
  },
  created() {
    console.log(JSON.stringify(this.tableHead));
    this.form.customerId = this.accountInfo.customerId;
    this.getStructure();
    this.getaccountTable();
  },
  methods: {
    customerIdFun() {
      this.form.structureId = '';
      this.getaccountTable();
      this.getStructure();
    },
    getaccountTable() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      userList(obj).then(res => {
        if (res.fieldConfig) {
          console.log(res.fieldConfig, 'res.fieldConfig');
          this.tableHead = res.fieldConfig.map(item => {
            item.slots = {
              title: item.title
            };
            delete item.title;
            return item;
          });
          this.tableHead.push({
            slots: {
              title: '操作'
            },
            scopedSlots: {
              customRender: 'action'
            },
            align: 'center',
            width: 200,
            fixed: 'right'
          });
        }
        console.log(res.items, '5555');
        this.tableData = res.items.map(item => {
          item.uploadMandatory = item.uploadMandatory || 0;
          return item;
        }) || [];
        this.pagination.total = res.totalNum;
      });
    },
    getStructure() {
      console.log(this.accountInfo);
      structureList({
        customerId: this.form.customerId,
        structureId: this.accountInfo.structureId
      }).then(res => {
        this.data = res;
      });
    },
    handleAdd() {},
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getaccountTable();
    },
    handleNodeClick(data) {
      console.log(data);
      this.form.structureId = data.id;
      this.getaccountTable();
    },
    editDepartment(node, data) {
      this.departmentDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.departmentModel.init(this.form.customerId, data);
      });
    },
    addDepartment(node, data) {
      this.departmentDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.departmentModel.init(this.form.customerId, data, true);
      });
    },
    delDepartment(node, data) {
      let _this = this;
      userList({
        page: 1,
        pageSize: 10,
        customerId: this.form.customerId,
        structureId: data.id
      }).then(res => {
        console.log(res.items);
        if (res.items.length == 0) {
          this.$alert(this.$t('是否确认删除该部门'), {
            confirmButtonText: this.$t('确定')
          }).then(() => {
            deleteDepartment({
              structureId: data.id
            }).then(res => {
              _this.$message.success(this.$t('删除成功'));
              _this.getaccountTable();
              _this.getStructure();
            });
          });
        } else {
          this.$message.error(this.$t('该部门下还有账号存在，暂时无法删除'));
        }
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该账号？'), {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        deleteTable({
          customerId: this.form.customerId,
          userId: val.id
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getaccountTable();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('customer.userStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      accountStatus({
        customerId: this.form.customerId,
        userId: val.id,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    handleChangeUploadMandatoryStatus(row) {
      let params = {
        userId: row.id,
        uploadMandatory: row.uploadMandatory == 1 ? 0 : 1
      };
      changeUploadMandatoryStatus(params).then(res => {
        this.$message.success(this.$t('操作成功'));
        row.uploadMandatory = row.uploadMandatory == 1 ? 0 : 1;
      });
    },
    toConfigNoticeTemplate(row) {
      this.configRow = row;
      this.selectNoticeTemplateVisible = true;
      this.$refs.selectNoticeTemplateModel.init();
    },
    downloadBackNoticeTemplateInfoFunc() {
      this.downLoading = true;
      downloadBackNoticeTemplateInfo({
        policyId: this.$route.params.id
      }).then(res => {
        console.log(res, 'downloadBackNoticeTemplateInfoFunc');
        if (res) {
          // let fileName = decodeURIComponent(
          //   res.headers['content-disposition']
          //     .split(';')[2]
          //     .split('=')[1]
          //     .replace(/^\"|\"$/g, '')
          //     .replace(/utf-8''/, '')
          // );
          let fileName = '投保告知书上传情况.xlsx';
          downloadFileFun(res, 'application/vnd.ms-excel', fileName);
        }
      }).finally(() => {
        this.downLoading = false;
      });
    }
  }
};